import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/public-sans/wght.css';
import './estilos/sistema/tokens.css';
import './estilos/sistema/base.css';
import './estilos/sistema/primitivos.css';
import './estilos/sistema/compartidos.css';
import './index.css';
import { ErrorBoundary } from './componentes/comunes/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { protegerCamposNumericos } from './utilidades/camposNumericos';

// Precios y cantidades: la rueda del mouse no los cambia y solo se escriben números.
protegerCamposNumericos();

const root = ReactDOM.createRoot(document.getElementById('root'));
const montar = (App) => root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// La compilacion Android no monta ni importa los paneles administrativos.
// El build web no define REACT_APP_TARGET y webpack no puede descartar esta
// rama: con import() la app móvil (portales, Capacitor) queda en un paquete
// aparte que la web nunca pide, en vez de viajar dentro del inicial.
if (process.env.REACT_APP_TARGET === 'android') {
  document.querySelector('meta[name="viewport"]')?.setAttribute('content',
    'width=device-width, initial-scale=1.0, viewport-fit=cover');
  import('./movil/AppMovil').then(({ default: AppMovil }) => montar(AppMovil));
} else {
  montar(require('./App').default);
}

// ✅ Registrar Service Worker con auto-update
// La tienda pública no lo registra: el comprador no instala la app ni la usa sin
// conexión. Así no precarga el panel completo, no consulta actualizaciones cada
// minuto y un deploy no le recarga la página a mitad de la compra.
// La tablet de ingreso (/kiosco) tampoco: no necesita el panel precargado.
const esTiendaPublica = /^\/(catalogo|seguimiento)\/|^\/kiosco(\/|$)/.test(window.location.pathname);
if (process.env.REACT_APP_TARGET !== 'android' && !esTiendaPublica) serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Disparar evento custom que App.js escucha para mostrar el banner
    const event = new CustomEvent('swUpdate', { detail: registration });
    window.dispatchEvent(event);
  }
});

reportWebVitals();
